/* eslint-disable no-template-curly-in-string */
export default {
  validations: {
    errors: {
      required: "「${label}」が未入力です。",
      maxLength: "「${label}」は、{max}文字以内で入力してください。（{current}文字入力されています。）",
      email: {
        missingAtSign: "正しいメールアドレスを入力してください。",
        isValidCharacters:
          "申し訳ございませんが、文字（a～z）、数字（0~9）、ピリオド（.）、ハイフン（-）、およびアンダースコア（_）、プラス（+）のみを使用できます。",
      },
      min: "${label}は${min}以上の整数を入力してください。",
      max: "${label}は${max}以下の整数を入力してください。",
      password:
        "パスワードは半角英数字を含む${min}文字以上${max}文字以内で入力してください。スペースは使用できません。",
      text: "「${label}」半角英数字・ドット・アンダースコアのみ使用してください。",
      katakanaField: "「${label}」は、全角カタカナで入力してください。",
      upload: "選択したファイルの形式が不正です。「{acceptTypes}」ファイルのみご選択ください。",
    },
  },
  header: {
    accountSetting: {
      changePassword: "パスワード再設定",
      changePasswordSuccess: "パスワード再設定メールをお送りしました。",
    },
    logout: "ログアウト",
  },
  table: {
    total: "全{total}件中{start}～{end}件目",
    textEmpty: "該当するデータがありません",
  },
  button: {
    save: "保存",
  },
  modal: {
    successDescription: "入力内容を保存しました。",
    successCancelDescription: "入力内容を取り消しました。",
    confirmDiscardEditedContentDescription: "編集内容を破棄しますか？",
    confirmCancel: "変更された内容を取り消しますか？",
    confirmSubmit: "入力した内容を保存しますか？",
    confirmLeavePage: "このページから移動しますか？",
    confirmLeavePageAlert: "行った変更が保存されない可能性があります。",
    errorTitle: "エラーがあります",
    confirmLogout: "ログアウトしますか？",
    errorContent: "サーバーへの接続に失敗しました。\nネットワーク接続を確認し、再試行してください。",
    btn: {
      ok: "削除",
      okSubmit: "保存",
      okCancel: "OK",
      cancel: "キャンセル",
    },
  },
  rangePicker: {
    startDate: "開始日",
    endDate: "無効日",
  },
  dragger: {
    title: "ファイルをここにドラッグアンドドロップ",
    button: "またはファイルを選択",
    error: {
      extension: "選択したファイルの形式が不正です。「{types}」ファイルのみご選択ください。",
      emptySize: "選択したファイルが空のようです。中身のあるファイルをご選択ください。",
      maxSize: "選択したファイルのサイズが最大値を越えています。 {size}以内のファイルをご選択ください。",
      maxCount: "あと{max}点までアイテムをアップロードできます。（現在、{current}点が選択されています。）",
    },
  },
  errors: {
    title: "ページを表示できませんでした。",
    403: "このページにアクセスする権限がありません。",
    404: "ご指定のURLは無効です。",
    500: "データが存在しないか、アクセス権限がありません。",
  },
  mediaUpload: {
    title: "ファイルをアップロード",
    modal: {
      deleteConfirm: "このファイルを削除しますか？",
      deleteSuccess: "ファイルを削除しました。",
    },
  },
}
